import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
    'inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium leading-tight',
    {
        variants: {
            tone: {
                neutral: 'bg-muted text-foreground',
                primary: 'bg-primary-soft text-primary',
                accent: 'bg-primary-soft text-primary',
                success: 'bg-success-soft text-success-foreground',
                warning: 'bg-warning-soft text-warning',
                info: 'bg-info-soft text-info',
                danger: 'bg-destructive/10 text-destructive',
                outline: 'border border-border text-foreground',
            },
        },
        defaultVariants: {
            tone: 'neutral',
        },
    },
);

export function Badge({ tone, className, children, ...props }) {
    return (
        <span className={cn(badgeVariants({ tone }), className)} {...props}>
            {children}
        </span>
    );
}
